import React from "react";
import "./ExamPrep.css";

const B1ExamPrep = () => {
  return (
    <div className="a1ExamPrepCover">
      <h3>
        Goethe <span>B1 Exam</span> Preparation
      </h3>
      <p>
        B1 level is considered an intermediate level. To prepare for the Goethe
        B1:
      </p>
      <ul>
        <li>
          Enhance your reading with articles, short stories, or reports. Pay
          attention to understanding the main ideas, vocabulary, and specific
          details.
        </li>
        <li>
          Work on writing letters, emails, or essays on various topics, focusing
          on coherence, grammar, and vocabulary usage.
        </li>
        <li>
          Practice listening to a variety of audio materials, including
          conversations, interviews, or news reports, and work on understanding
          spoken language, identifying key information, and following the
          context.
        </li>
      </ul>
    </div>
  );
};

export default B1ExamPrep;
